module.exports = __webpack_public_path__ + "img/ch.a64f3ca6.jpg";